module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": "",
      "md4": "",
      "offset-md4": ""
    }
  }, [_c('div', {
    staticClass: "my-5 display-1"
  }, [_vm._v("Registracija")]), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register($event)
      }
    }
  }, [(_vm.info) ? _c('p', {
    staticClass: "multi-line mb-4",
    attrs: {
      "value": true,
      "type": "info"
    },
    domProps: {
      "textContent": _vm._s(_vm.info)
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn-toggle', {
    staticClass: "mb-4",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "mandatory": ""
    },
    model: {
      value: (_vm.accountType),
      callback: function($$v) {
        _vm.accountType = $$v
      },
      expression: "accountType"
    }
  }, _vm._l((_vm.accountTypes), function(accountType, i) {
    return _c('v-btn', {
      key: i,
      staticClass: "primary",
      attrs: {
        "large": "",
        "block": "",
        "width": "33%",
        "value": accountType.type
      }
    }, [_vm._v("\n            " + _vm._s(accountType.label) + "\n          ")])
  })), _vm._v(" "), _c('v-text-field', {
    ref: "name",
    attrs: {
      "label": _vm.accountType == 'courier' ? 'ime i prezime' : 'naziv',
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "phone",
    attrs: {
      "label": "telefon",
      "required": "",
      "autocomplete": "phone"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "email",
    attrs: {
      "label": "email",
      "required": "",
      "autocomplete": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "lozinka",
      "required": "",
      "autocomplete": "new-password",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password'
    },
    on: {
      "click:append": function () { return (_vm.showPassword = !_vm.showPassword); }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "potvrda lozinke",
      "required": "",
      "autocomplete": "new-password",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password'
    },
    on: {
      "click:append": function () { return (_vm.showPassword = !_vm.showPassword); }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), (_vm.success) ? _c('v-alert', {
    staticClass: "multi-line",
    attrs: {
      "value": true,
      "type": "success"
    },
    domProps: {
      "textContent": _vm._s(_vm.success)
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary my-5",
    attrs: {
      "large": "",
      "block": "",
      "type": "submit",
      "disabled": !_vm.valid,
      "loading": _vm.loading
    }
  }, [_vm._v("registracija")]), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "textContent": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}